export default __webpack_public_path__ + "static/media/empty-specification.9a896953.svg";